import api from "./api";

const BASE = "/Shipment";

const unwrap = (res) => {
    const d = res?.data;
    if (Array.isArray(d)) return d;
    return d?.data ?? d;
};

export const createShipment = async (payload = {}) =>
    unwrap(await api.post(BASE, {
        paymentStatus: payload.paymentStatus ?? 0,
        clientId: payload.clientId ?? null
    }));

export const getShipmentById = async (id) =>
    unwrap(await api.get(`${BASE}/${id}`));

export const updateShipment = async (id, shipment) =>
    unwrap(await api.put(`${BASE}/${id}`, shipment));

export const deleteShipment = async (id) =>
    unwrap(await api.delete(`${BASE}/${id}`));

export const addItemToShipment = async (id, item) =>
    unwrap(await api.post(`${BASE}/${id}/items`, item));

export const getShipments = async () =>
    unwrap(await api.get(`${BASE}/my`));

export const getAllShipments = async () =>
    unwrap(await api.get(`${BASE}/all`));

export default {
    createShipment,
    getAllShipments,
    getShipmentById,
    updateShipment,
    deleteShipment,
    addItemToShipment,
    getShipments
};